if (!customElements.get('social-gallery')) {
  class SocialGallery extends HTMLElement {
    constructor() {
      super();

      this.cardButtons = this.querySelectorAll('[data-social-gallery-card-button]');
      this.popup = this.querySelector('[data-social-gallery-popup]');
      this.popupCloseButton = this.querySelector('[data-social-gallery-popup-close]');
      this.videoPlayButtons = this.querySelectorAll('[data-video-play-button]');
      this.videoWrappers = this.querySelectorAll('[data-video-wrapper]');

      this.mobileCarouselInit();
      this.popupCarouselInit();
      this.storySwiperInit();

      window.addEventListener('keyup', () => {
        if (!document.activeElement.closest('[data-social-gallery-popup]') && this.popup.classList.contains('active') && event.code.toUpperCase() === 'TAB') {
          window.trapFocus(this.popup, this.popupCloseButton);
        }
      });

      if (this.cardButtons) {
        this.cardButtons.forEach((cardButton) => {
          cardButton.addEventListener('click', this.openPopup.bind(this));
        });
      }

      if (this.popupCloseButton) {
        this.popupCloseButton.addEventListener('click', this.closePopup.bind(this));
      }

      if (this.videoPlayButtons) {
        this.videoPlayButtons.forEach((videoPlayButton) => {
          videoPlayButton.addEventListener('click', () => {
            this.dispatchEvent(new Event('socialGalleryVideoPlaying'));
          });
        });
      }

      this.addEventListener('keydown', (event) => {
        if (event.keyCode !== 27) { return; }

        this.closePopup();
      });

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:unload', () => {
          if (this.popup.classList.contains('active')) {
            localStorage.setItem('open-social-gallery', 'true');
          }

          this.closePopup();
        });

        document.addEventListener('shopify:section:load', (event) => {
          if (event.target.querySelector('social-gallery') !== this || localStorage.getItem('open-social-gallery') !== 'true') { return; }

          const lastCardIndex = localStorage.getItem('card-button-index') ? (parseInt(localStorage.getItem('card-button-index'), 10) - 1) : 0;

          localStorage.removeItem('open-social-gallery');

          this.cardButtons[lastCardIndex].click();
        });
      }
    }

    mobileCarouselInit() {
      const carousel = this.querySelector('[data-social-gallery-mobile-carousel]');

      if (!carousel) { return; }

      const swiper = new window.Swiper(carousel, {
        spaceBetween: 16,
        slidesPerView: 'auto',
        draggable: true,
        loop: true
      });

      return swiper;
    }

    storySwiperInit() {
      const storySwipers = this.querySelectorAll('[data-social-gallery-story]');

      storySwipers.forEach((storySwiper) => {
        if (!storySwiper) { return; }

        const prevButton = storySwiper.querySelector('[data-swiper-prev]');
        const nextButton = storySwiper.querySelector('[data-swiper-next]');
        const pagination = storySwiper.querySelector('[data-swiper-pagination]');
        const pause = storySwiper.querySelector('[data-swiper-pause]');
        const count = storySwiper.querySelector('[data-swiper-count]');
        let videos = storySwiper.querySelectorAll('video');

        const swiper = new window.Swiper(storySwiper, {
          spaceBetween: 0,
          slidesPerView: 1,
          noSwiping: true,
          noSwipingClass: 'swiper-slide',
          loop: true,
          navigation: {
            prevEl: prevButton,
            nextEl: nextButton
          },
          pagination: {
            el: pagination,
            clickable: true
          },
          autoplay: {
            delay: 6000,
            disableOnInteraction: false
          }
        });

        this.addEventListener('keyup', (event) => {
          if (this.popup.classList.contains('d-none') || !storySwiper.closest('[data-social-gallery-popup-slide].swiper-slide-active')) { return; }

          if (event.keyCode == 37) {
            swiper.slidePrev();
          } else if (event.keyCode == 39) {
            swiper.slideNext();
          }
        });

        if (pause) {
          pause.addEventListener('click', () => {
            const allPauseButtons = this.querySelectorAll('[data-swiper-pause]');

            allPauseButtons.forEach((pauseButton) => {
              pauseButton.classList.toggle('active');
            });

            if (pause.classList.contains('active')) {
              this.dispatchEvent(new Event('pauseSocialGalleryStories'));
            } else {
              this.dispatchEvent(new Event('startSocialGalleryStories'));
            }
          });
        }

        window.addEventListener('resize', () => {
          swiper.update();
        });

        swiper.on('reachBeginning', () => {
          if (!storySwiper.closest('[data-social-gallery-popup-slide].swiper-slide-active')) { return; }
          this.dispatchEvent(new Event('socialGalleryGoToPrevStory'));
        });

        swiper.on('reachEnd', () => {
          if (!storySwiper.closest('[data-social-gallery-popup-slide].swiper-slide-active')) { return; }
          this.dispatchEvent(new Event('socialGalleryGoToNextStory'));
        });

        swiper.on('slideChangeTransitionStart', () => {
          storySwiper.classList.remove('social-gallery-story--vimeo-video');
          this.stopVideos();

          if (videos.length) {
            videos = storySwiper.querySelectorAll('video');

            videos.forEach((video) => {
              video.onended = () => {
                if (storySwiper.classList.contains('swiper-paused')) { return; }
                swiper.slideNext();
              };
            });
          }

          if (count) {
            const activeSlide = storySwiper.querySelector('.swiper-slide-active');

            if (activeSlide) {
              count.innerHTML = `0${parseInt(activeSlide.getAttribute('data-swiper-slide-index')) + 1}`;
            }
          }

          if (!storySwiper.classList.contains('swiper-paused')) {
            swiper.autoplay.start();
          }

          if (this.hasAttribute('data-social-gallery-autoplay') && storySwiper.closest('[data-social-gallery-popup-slide].swiper-slide-active')) {
            const activeSlide = storySwiper.querySelector('.swiper-slide-active');
            const activeSlideVideoButton = activeSlide ? activeSlide.querySelector('[data-video-play-button]') : null;

            if (activeSlideVideoButton) {
              activeSlideVideoButton.click();
              this.dispatchEvent(new Event('socialGalleryVideoPlaying'));
            }
          }

          const paginationItems = pagination.querySelectorAll('.swiper-pagination-bullet');

          if (paginationItems.length) {
            paginationItems.forEach((paginationItem, index) => {
              if (index + 1 < swiper.activeIndex) {
                paginationItem.classList.add('swiper-pagination-bullet--filled');
              } else {
                paginationItem.classList.remove('swiper-pagination-bullet--filled');
              }

              paginationItem.addEventListener('keyup', (event) => {
                if (event.keyCode != 13) { return; }

                const slideIndex = paginationItem.getAttribute('aria-label').split('slide ')[1];

                swiper.slideTo(slideIndex);
              });
            });
          }
        });

        this.addEventListener('pauseSocialGalleryStories', () => {
          storySwiper.classList.add('swiper-paused');
          swiper.autoplay.stop();
        });

        this.addEventListener('startSocialGalleryStories', () => {
          storySwiper.classList.remove('swiper-paused');
          swiper.autoplay.start();
        });

        this.addEventListener('socialGalleryGoToFirstSlide', () => {
          if (!storySwiper.closest('[data-social-gallery-popup-slide].swiper-slide-active')) { return; }

          swiper.slideTo(1, 0, false);

          setTimeout(() => {
            const paginationItems = pagination.querySelectorAll('.swiper-pagination-bullet');

            if (paginationItems.length) {
              paginationItems.forEach((paginationItem) => {
                paginationItem.classList.remove('swiper-pagination-bullet--filled');
              });
            }
          }, 10);

          if (!storySwiper.classList.contains('swiper-paused')) {
            storySwiper.classList.add('no-animation');
            swiper.autoplay.stop();
            swiper.autoplay.start();

            setTimeout(() => {
              storySwiper.classList.remove('no-animation');
            }, 10);
          }
        });

        this.addEventListener('socialGalleryVideoPlaying', () => {
          swiper.autoplay.stop();
          const activeSlide = storySwiper.querySelector('.swiper-slide-active');
          const activeSlideIframe = activeSlide.querySelector('iframe');

          if (activeSlideIframe && activeSlideIframe.getAttribute('src').indexOf('vimeo') >= 0) {
            storySwiper.classList.add('social-gallery-story--vimeo-video');
          }
        });

        storySwiper.addEventListener('mouseover', () => {
          this.classList.add('social-gallery--hide-controls');
        });

        storySwiper.addEventListener('mouseleave', () => {
          this.classList.remove('social-gallery--hide-controls');
        });

        return swiper;
      });
    }

    popupCarouselInit() {
      const popupCarousel = this.querySelector('[data-social-gallery-popup-carousel]');

      if (!popupCarousel) { return; }

      const prevButton = this.querySelector('[data-swiper-prev]');
      const nextButton = this.querySelector('[data-swiper-next]');

      const swiper = new window.Swiper(popupCarousel, {
        spaceBetween: 24,
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          768: {
            allowTouchMove: false,
            draggable: false,
            speed: 0,
            slidesPerView: 2,
          },
          1025: {
            allowTouchMove: false,
            draggable: false,
            speed: 0,
            slidesPerView: 'auto'
          }
        },
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton
        }
      });

      this.addEventListener('keyup', (event) => {
        if (this.popup.classList.contains('d-none')) { return; }

        if (event.keyCode == 40) {
          swiper.slidePrev();
        } else if (event.keyCode == 38) {
          swiper.slideNext();
        }
      });

      this.addEventListener('socialGalleryGoToPrevStory', () => {
        swiper.slidePrev();
        focusActiveSlide();
      });

      this.addEventListener('socialGalleryGoToNextStory', () => {
        swiper.slideNext();
        focusActiveSlide();
      });

      swiper.on('slideChangeTransitionStart', () => {
        this.dispatchEvent(new Event('socialGalleryGoToFirstSlide'));
        swiper.update();
        this.stopVideos();
      });

      swiper.on('slideChangeTransitionEnd', () => {
        updateTabIndex();

        if (this.videoPlayButtons) {
          this.videoPlayButtons.forEach((videoPlayButton) => {
            videoPlayButton.setAttribute('tabindex', '-1');
          });
        }

        setTimeout(() => {
          const activeSlide = popupCarousel.querySelector('[data-social-gallery-popup-slide].swiper-slide-active .swiper-slide-active');
          const activeSlideVideoButton = activeSlide ? activeSlide.querySelector('[data-video-play-button]') : null;

          if (activeSlideVideoButton) {
            activeSlideVideoButton.setAttribute('tabindex', '0');

            if (this.hasAttribute('data-social-gallery-autoplay') && this.popup.classList.contains('video-ready')) {
              activeSlideVideoButton.click();
              this.dispatchEvent(new Event('socialGalleryVideoPlaying'));
            }
          }
        }, 200);
      });

      function focusActiveSlide () {
        popupCarousel.querySelectorAll('.swiper-arrow').forEach((swiperArrow) => {
          if (document.activeElement != swiperArrow) { return; }

          setTimeout(() => {
            popupCarousel.querySelector('.swiper-slide-active .swiper-pagination-bullet').focus();
          }, 200);
        });
      }

      updateTabIndex();

      function updateTabIndex() {
        const slides = popupCarousel.querySelectorAll('[data-social-gallery-popup-slide]');

        slides.forEach((slide) => {
          if (slide.classList.contains('swiper-slide-active')) {
            slide.setAttribute('tabindex', 0);

            slide.querySelectorAll('[tabindex], a, button, .swiper-pagination-bullet').forEach((item) => {
              item.setAttribute('tabindex', 0);
            });
          } else {
            slide.setAttribute('tabindex', -1);

            slide.querySelectorAll('[tabindex], a, button, .swiper-pagination-bullet').forEach((item) => {
              item.setAttribute('tabindex', -1);
            });
          }

          setTimeout(() => {
            if (slide.classList.contains('swiper-slide-duplicate')) {
              slide.setAttribute('tabindex', -1);

              slide.querySelectorAll('[tabindex], a, button, .swiper-pagination-bullet').forEach((item) => {
                item.setAttribute('tabindex', -1);
              });
            }
          }, 400);
        });
      }

      window.addEventListener('resize', () => {
        swiper.update();
      });

      popupCarousel.addEventListener('click', (event) => {
        if (!event.target.classList.contains('swiper-slide')) { return; }

        const index = parseInt(event.target.getAttribute('data-swiper-slide-index'), 10);

        swiper.slideTo(index);
        swiper.slideNext(0, false);
        swiper.slidePrev(0, false);
        swiper.update();
        this.dispatchEvent(new Event('socialGalleryGoToFirstSlide'));
      });

      this.addEventListener('openPopup', (event) => {
        let slideIndex = parseInt(event.detail, 10);

        if (window.innerWidth >= 1025) {
          slideIndex = parseInt(event.detail, 10) - 1;
        } else if (window.innerWidth >= 768 && window.innerWidth < 1025) {
          slideIndex = parseInt(event.detail, 10) + 1;
        }

        swiper.slideTo(slideIndex);
        nextButton.click();
        prevButton.click();

        setTimeout(() => {
          const activeSlide = popupCarousel.querySelector('[data-social-gallery-popup-slide].swiper-slide-active .swiper-slide-active');
          const activeSlideVideoButton = activeSlide ? activeSlide.querySelector('[data-video-play-button]') : null;

          if (this.hasAttribute('data-social-gallery-autoplay') && activeSlideVideoButton) {
            activeSlideVideoButton.click();
            this.dispatchEvent(new Event('socialGalleryVideoPlaying'));
          }
        }, 200);

        setTimeout(() => {
          this.popup.classList.add('video-ready');
        }, 500);
      });

      return swiper;
    }

    openPopup(event) {
      this.popup.classList.remove('d-none');

      setTimeout(() => {
        window.trapFocus(this.popup, this.popupCloseButton);
        this.popup.classList.add('active');
      }, 100);

      if (!Shopify.designMode) {
        window.scrollLock();
      }

      localStorage.setItem('card-button-index', event.target.getAttribute('data-index'));
      this.dispatchEvent(new CustomEvent('openPopup', { detail: event.target.getAttribute('data-index') }));
    }

    closePopup() {
      this.popup.classList.add('d-none');
      this.popup.classList.remove('active', 'video-ready');
      this.stopVideos();

      window.removeTrapFocus();
      window.removeScrollLock();

      if (document.body.classList.contains('tab-outline')) {
        this.cardButtons[0].focus();
      }
    }

    stopVideos() {
      this.videoPlayButtons = this.querySelectorAll('[data-video-play-button]');
      this.videoWrappers = this.querySelectorAll('[data-video-wrapper]');

      if (this.videoPlayButtons) {
        this.videoPlayButtons.forEach((videoPlayButton) => {
          videoPlayButton.classList.remove('d-none');
        });
      }

      if (this.videoWrappers) {
        this.videoWrappers.forEach((videoWrapper) => {
          videoWrapper.classList.add('d-none');

          const videoIframe = videoWrapper.querySelector('iframe');
          const videoElement = videoWrapper.querySelector('video');

          if (videoIframe) {
            videoIframe.setAttribute('src', '');
          } else if (videoElement) {
            videoElement.pause();
            videoElement.removeAttribute('controls');
          }
        });
      }
    }
  }

  customElements.define('social-gallery', SocialGallery);
}